import styled from "styled-components";

/**
 * The generic SI page frame: a centred, max-width column with the standard gutters.
 *
 * It grew inside `pages/lists/` and was named for it, but Enrichment, Manage Signals and Signal
 * Recommender render inside it too — each page reaching into a sibling page for its own frame. Unlike the
 * `Leads`-prefixed chrome next door, this is scoped to no page in particular, so the name says so.
 */
export const StyledPageContainer = styled.div`
    height: auto;
    padding-bottom: 50px;
    margin: 0 auto;
    max-width: 1224px;
    width: 100%;
`;

export const PageInnerContainer = styled.div`
    height: 100%;
    padding-left: 72px;
    padding-right: 72px;
`;
